module.exports = __webpack_public_path__ + "static/media/ITN_logo.899cd278.svg";